import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BillsVService } from '../../services/V2/gozer';
import { handleError } from './Functions';

export function Bill({ hide, show, billingAccountId, billId, fail }) {
    const [bill, setBill] = useState<any>();
    const [src, setSrc] = useState<string>("");

    useEffect(() => {
        if(!billId) {
            BillsVService.billsVGetPastTwoYears(billingAccountId)
                .then((b: any) => {
                    var newestBill = b.find(x => x.billStoredObjectId !== null);
                    setBill(newestBill);
                    BillsVService.billsVGetAttachment(billingAccountId, newestBill.id ?? "")
                        .then(x => setSrc(x.preSignedUrl ?? "error"))
                        .catch(err => setSrc("error"))
                })
                .catch(err => setSrc("error"))
        } else {
            BillsVService.billsVGetPastTwoYears(billingAccountId)
                .then((b: any) => {
                    var bill = b.find(x => x.id === billId)
                    setBill(bill);
                })
                .catch(err => err.message !=="Not Found" && fail(handleError(err)))
            BillsVService.billsVGetAttachment(billingAccountId, billId)
                .then(x => setSrc(x.preSignedUrl ?? "error"))
                .catch(err => setSrc("error"))
        }
    }, [billingAccountId, billId])// eslint-disable-line react-hooks/exhaustive-deps

    return <>
        <Dialog onClose={hide} open={show} fullWidth>
            <DialogTitle>Billing Statement {bill?.billingCycle ? `(${bill.billingCycle.cycleMonth}/${bill.billingCycle.cycleYear})` : ``}</DialogTitle>
            <DialogContent>
                {src === "" ?
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
                    src === "error" ?
                        <div style={{ textAlign:"center" }}>There was an error loading the bill.</div> :
                        <iframe title="bill" style={{ width: "100%", height: "75vh" }} src={src} />
                }
            </DialogContent>
            <DialogActions className='bill-buttons-group'>
                <Button variant="outlined" onClick={hide}>Close</Button>
            </DialogActions>
        </Dialog>
    </>
}
